/*
 * Copyright (c) 2024. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import {useDispatch} from "useDispatch";
import React, {useEffect} from "react";
import Loader from "components/Loader";
import CardComponent from "pages/Front/Booking/components/CardComponent";
import {useTypedSelector} from "helpers/reducers";
import SessionAction from "store/session/SessionAction";
import HallAction from "store/hall/HallAction";
import {DEFAULT_HALL_ID} from "helpers/config";

interface BookingPaidProps {
    children: React.ReactNode | React.ReactNode[];
}

const BookingTerms = (props: BookingPaidProps) => {
    const dispatch = useDispatch();
    const hall = useTypedSelector(state => state.hallState?.hall) || null;

    useEffect(() => {
        if (!hall) {
            dispatch(SessionAction.loginVisitor());
            dispatch(HallAction.fetchHall(DEFAULT_HALL_ID)).then(r => {});
        }
    }, []);
    if (!hall) {
        return <Loader />;
    }

    return (
        <div className={"BookingTerms w-full flex flex-col justify-start items-stretch space-y-2 sm:space-y-8 py-8 lg:flex-wrap"}>
            <CardComponent>{props.children}</CardComponent>
        </div>
    );
};

export default BookingTerms;
